import { Component, HostListener, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationMessage, ConfirmationResult } from '@shared/_constants';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { ConfigService } from '@services/config.service';
import { select, Store } from '@ngrx/store';
import { selectIsGenerativeAiEnabledAppSetting } from 'src/app/app.selectors';
import { AppState } from 'src/app/reducers';
import { DialogService } from '@services/dialog.service';

@Component({
  selector: 'app-screen-version-notice',
  templateUrl: './screen-version-notice.component.html',
  styleUrls: ['./screen-version-notice.component.css'],
})
@HostListener('scroll', ['$event'])
export class ScreenVersionNoticeComponent implements OnDestroy {
  private destroy$ = new Subject();
  public isGenerativeAiEnabled = false;
  isActive = true;

  ngOnDestroy(): void {
    this.destroy$.next('');
  }

  constructor(
    private activeModal: NgbActiveModal,
    private store: Store<AppState>,
    private dialogService: DialogService,
  ) {
    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectIsGenerativeAiEnabledAppSetting))
      .subscribe((aiEnabled) => (this.isGenerativeAiEnabled = aiEnabled.toLowerCase() == 'false' ? false : true));
    sessionStorage.setItem('screenVersionDisplayed', '1');
  }

  public async goToGenAIVersion() {
    const confirmationResult = await this.dialogService.confirm(
      'Please Confirm',
      ConfirmationMessage.WelcomeScreenConfirmationMessage,
      'Back',
      'Acknowledge',
    );
    if (confirmationResult === ConfirmationResult.yes) this.activeModal.close(ConfirmationResult.yes);
    if (confirmationResult === ConfirmationResult.no) {
      this.activeModal.close(ConfirmationResult.no);
    }
  }

  public async proceed() {
    this.activeModal.close(ConfirmationResult.yes);
  }

  public async close() {
    this.activeModal.close(ConfirmationResult.no);
  }
  public async acknowledge() {
    this.activeModal.close(ConfirmationResult.yes);
  }
  scroll(element) {
    if (element != null) {
      element.scrollIntoView();
    }
  }
}
